import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'

import { cn } from '@/utils'
import type { AccountSort, AccountSortKey } from './accountLines'

interface SortHeaderProps {
  label: string
  sortKey: AccountSortKey
  sort: AccountSort
  onSort: (key: AccountSortKey) => void
  alignRight?: boolean
}

export const SortHeader = ({
  label,
  sortKey,
  sort,
  onSort,
  alignRight = false,
}: SortHeaderProps) => {
  const isSorted = sort.key === sortKey
  const Arrow = sort.direction === 'asc' ? ArrowUpIcon : ArrowDownIcon
  return (
    <th
      aria-sort={
        isSorted
          ? sort.direction === 'asc'
            ? 'ascending'
            : 'descending'
          : 'none'
      }
      className={cn(
        'border-b px-3 pb-2.5 align-bottom text-xs font-normal',
        alignRight ? 'text-right' : 'text-left',
        isSorted ? 'text-blue-7' : 'text-ink-subtle',
      )}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn(
          'cursor-pointer hover:text-blue-7',
          alignRight ? 'text-right' : 'text-left',
        )}
      >
        {label}
        {isSorted && (
          <Arrow className="ml-1 inline size-3 align-[-2px] text-blue-7" />
        )}
      </button>
    </th>
  )
}
